/**
 * Strip HTML tags from a string to get plain text
 * @param {string} html - HTML string
 * @returns {string} Plain text without HTML tags
 */
export const stripHtmlTags = (html) => {
  if (!html) return '';
  // Create a temporary div element
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};
